module.exports = __webpack_public_path__ + "img/eprf-edit.95625fc5.png";